export default __webpack_public_path__ + "static/media/Php.2ed8c8be.png";